import { styled } from '@linaria/react'
import React, { type FC } from 'react'
import type { BoxChoiceDto } from '../types/generated'
import { VoteOptionWithMeta } from './VoteOptionWithMeta'
import { calculateProfitability } from '../utils/calculateProfitability'

export const VoteButtonGroup: FC<{
  boxChoices: BoxChoiceDto[]
  className?: string
  isOpen: boolean
  onSelect: (choiceIndex: number) => void
  winnerChoiceIndex: number | null
  isProfitabilityShow?: boolean
}> = ({
  boxChoices,
  className,
  isOpen,
  onSelect,
  isProfitabilityShow,
  winnerChoiceIndex,
}) => {
  const totalVotes = boxChoices.reduce(
    (sum, choice) => sum + Number(choice.voteCount),
    0,
  )

  return (
    <Container className={className}>
      {boxChoices
        .sort((a, b) => a.choiceIndex - b.choiceIndex)
        .map(boxChoice => {
          const percent =
            totalVotes === 0
              ? 0
              : Math.round((Number(boxChoice.voteCount) / totalVotes) * 100)

          const userVoteSummary = boxChoice.user_vote_summary

          const hasUserVoted = Boolean(userVoteSummary)

          const userVotesCount = userVoteSummary
            ? Number(userVoteSummary.walletVotes)
            : 0

          const userTonAmount = userVoteSummary
            ? Number(userVoteSummary.totalTonStaked)
            : 0

          return (
            <VoteOptionWithMeta
              key={boxChoice.choiceIndex}
              option={{
                percent,
                userVotes: userVotesCount,
                userTon: userTonAmount,
                choice: boxChoice.choice,
                voteCount: boxChoice.voteCount,
                choiceIndex: boxChoice.choiceIndex,
                votesSubmitted: userVoteSummary?.votesSubmitted,
              }}
              checked={hasUserVoted}
              disabled={!isOpen}
              onChange={onSelect}
              profitabilityPercent={calculateProfitability(boxChoice)}
              isRightAnswer={
                winnerChoiceIndex !== null
                  ? winnerChoiceIndex === boxChoice.choiceIndex
                  : null
              }
              isProfitabilityShow={isProfitabilityShow}
            />
          )
        })}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
